import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-6-9a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zM4.929 6.343A1 1 0 0 1 6.343 4.93l.707.707A1 1 0 1 1 5.636 7.05zM3 13a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2zm3.343 6.071a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 1.414zM11 20a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm5.95-1.636a1 1 0 0 1 1.414-1.414l.707.707a1 1 0 0 1-1.414 1.414zM20 13a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2zm-1.636-5.95a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 1 1 1.414 1.414z"
    }
  )
);
var SvgSunFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SunFilled_default = SvgSunFilled;

export { SunFilled_default as default };
